// extracted by mini-css-extract-plugin
export default {"AdhdTitle1":"iStyles_AdhdTitle1__O-VNY","AdhdTitle1_":"iStyles_AdhdTitle1___KG-CG","AdhdTitle2":"iStyles_AdhdTitle2__dzaVj","AdhdTitle3":"iStyles_AdhdTitle3__9nIyc"};